// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v9_L","newExpiryDate":"styles_newExpiryDate__3AAub","footer":"styles_footer__2-syc"};